import type { ProcessingStatus } from '@/shared/types';

/** Which step of the confirmation dialog a job's state calls for. */
export type ConfirmGenerationPhase =
  | 'preparing'
  | 'confirm'
  | 'failed'
  | 'confirmed'
  | 'cancelled';

/**
 * A `switch` with no `default`, deliberately. This began as a chain of `if`s
 * ending in a catch-all `return 'confirmed'`, which quietly swallowed
 * `cancelled` — so cancelling a job told the user it was now being processed.
 * Written exhaustively, the next status added to `ProcessingStatus` fails to
 * typecheck here instead of inheriting whatever the last branch happened to be.
 */
export function generationPhase(
  status: ProcessingStatus | undefined,
  estimatedCost: number | undefined,
): ConfirmGenerationPhase {
  switch (status) {
    case 'failed':
      return 'failed';
    case 'cancelled':
      return 'cancelled';
    case undefined:
    case 'queued':
    case 'processing':
      return 'preparing';
    case 'awaiting_confirmation':
      // No cost yet means the quote is still in flight — showing a confirm
      // button next to "Calculating…" invites a blind accept.
      return estimatedCost === undefined ? 'preparing' : 'confirm';
    case 'completed':
      return 'confirmed';
  }
}
